export default {
    /**
     * Sort array according given param
     *
     * @param {any[]} arrayOfStrings
     * @param {string} byParam
     * @returns
     */
    _sortArrayOfStringsByParam(arrayOfStrings: string[], byParam: string) {
        return arrayOfStrings.sort((a: any, b: any) => {
            const nameA = a[byParam].toLowerCase();
            const nameB = b[byParam].toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    },

    /**
     * Sort array according
     *
     * @param {any[]} arrayOfStrings
     * @returns
     */
    _sortArrayOfStrings(arrayOfStrings: string[]) {
        return arrayOfStrings.sort((a: any, b: any) => {
            const nameA = a.toLowerCase();
            const nameB = b.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }
};
